<template>
    <FormInput
        :label="texto_documento"
        :name="`${texto_documento}${index > 0 ? (' ' + index) : ''}`"
        :rules="{ required: true, identificacion: { tipo: type } }"
        :value="value"
        :disabled="!type"
        :id="`valor-documento-${index}`"
        @input="$emit('input', $event)"
    />
</template>

<script>
    import FormInput from "@/components/common/FormInput";

    export default {
        name: "DocumentoValor",
        props: {
            value: {
                type: String,
                default: ""
            },
            type: {
                type: String,
                default: null
            },
            index: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                texto_documento: "Documento"
            };
        },
        watch: {
            type(newVal) {
                switch (newVal) {
                    case 'DNI':
                        this.texto_documento = this.$t('formularios.dni').toUpperCase();
                        break;
                    case 'NIE':
                        this.texto_documento = this.$t('formularios.nie');
                        break;
                    case 'NIF':
                        this.texto_documento = this.$t('formularios.nif');
                        break;
                    case 'PASSPORT':
                        this.texto_documento = this.$t('formularios.pasaporte');
                        break;
                    default:
                        this.texto_documento = this.$t('formularios.tipo_identificacion');
                        break;
                }
            }
        },
        components: {
            FormInput
        }
    };
</script>
